import { ReactElement } from 'react';
import { Box, Snackbar, Typography, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';

import CustomButton from '../CustomButton';
import ProgressiveBars from '../ProgressiveBars';
import { TOAST_DURATION } from '../../consts/constants';
import { styles } from './CustomSnackbarStyles';

const CustomSnackbar = ({
  btnText,
  duration,
  horizontal,
  message,
  muiIcon,
  onToastBtnClick,
  onToastClose,
  open,
  showProgressiveLoader,
  type,
  vertical,
}: {
  btnText?: string;
  duration?: number;
  horizontal?: 'center' | 'right' | 'left';
  message: string;
  muiIcon?: ReactElement;
  onToastBtnClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onToastClose?: Function;
  open: boolean;
  showProgressiveLoader?: boolean;
  type?: string;
  vertical?: 'top' | 'bottom';
}) => {
  const theme = useTheme();
  const classes = styles(theme);

  return (
    <Snackbar
      open={open || false}
      autoHideDuration={duration ?? TOAST_DURATION}
      message={
        <Box sx={classes.toastContainer}>
          <Box sx={classes.iconAndTextBox}>
            {muiIcon ? (
              muiIcon
            ) : type === 'success' ? (
              <CheckCircleOutlineIcon />
            ) : (
              <ErrorIcon />
            )}
            <Typography component="span" sx={classes.messageStyles}>
              {message}
            </Typography>
          </Box>
          {(showProgressiveLoader || !!btnText) && (
            <Box sx={classes.loaderBtnBox}>
              {showProgressiveLoader && <ProgressiveBars />}
              {!!btnText && (
                <CustomButton
                  onClick={onToastBtnClick ? onToastBtnClick : () => {}}
                  isOutlinedBtn
                >
                  <>{btnText}</>
                </CustomButton>
              )}
            </Box>
          )}
        </Box>
      }
      anchorOrigin={{
        vertical: vertical ?? 'top',
        horizontal: horizontal ?? 'right',
      }}
      ContentProps={{
        sx: {
          backgroundColor:
            type === 'success'
              ? theme.palette.tertiary?.green
              : theme.palette.quinary?.main,
          color: theme.palette.text.elevenary,
          borderRadius: theme.custom.borderRadius.large,
        },
      }}
      onClose={(e, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        onToastClose && onToastClose();
      }}
    />
  );
};

export default CustomSnackbar;
